import { defineStore } from 'pinia';

let _sessionMonitorId = null;
let _inactivityLimit = 60 * 60 * 1000; // 1 hour
let _maxSessionDuration = 12 * 60 * 60 * 1000; // 12 hours

export const agentStore = defineStore('agentStore', {
  state: () => ({
    token: null,
    isLoggedIn: false,
    UserData: {},
    WalletBalance: { 'credit_expiry_date': 0, 'wallet_balance': 0, 'due_amount': 0, 'credit_limit': 0 },
    // session timestamps (persisted)
    loginTime: null, // epoch ms
    lastActivity: null, // epoch ms
  }),

  actions: {
    setIsLoggedIn(val = false) {
      this.isLoggedIn = val;
      if (val) {
        // start session monitor when logged in
        this.startSessionMonitor();
      } else {
        this.clearSessionMonitor();
      }
    },
    setToken(token) {
      this.token = token;
    },
    // call this on login to initialize timestamps and start monitor
    setLogin(token, userData = {}) {
      this.token = token;
      this.isLoggedIn = true;
      this.UserData = userData;
      const now = Date.now();
      this.loginTime = now;
      this.lastActivity = now;
      this.startSessionMonitor();
    },
    touchActivity() {
      // update last activity timestamp
      this.lastActivity = Date.now();
    },
    startSessionMonitor() {
      // ensure only one monitor runs
      this.clearSessionMonitor();
      // check every 30 seconds
      _sessionMonitorId = setInterval(() => {
        try {
          if (!this.isLoggedIn) return;
          const now = Date.now();
          if (this.lastActivity && (now - this.lastActivity) > _inactivityLimit) {
            // inactive too long => logout
            this.performLogout('inactive');
            return;
          }
          if (this.loginTime && (now - this.loginTime) > _maxSessionDuration) {
            // max session reached => logout
            this.performLogout('session_expired');
            return;
          }
        } catch (e) {
          console.error('Error occurred while checking session status:', e);
        }
      }, 1 * 1000);  // 30 seconds
    },
    clearSessionMonitor() {
      if (_sessionMonitorId) {
        clearInterval(_sessionMonitorId);
        _sessionMonitorId = null;
      }
    },
    performLogout(reason = '') {
      // clear persisted auth state
      this.token = null;
      this.isLoggedIn = false;
      this.UserData = {};
      this.WalletBalance = { 'credit_expiry_date': 0, 'wallet_balance': 0, 'due_amount': 0, 'credit_limit': 0 };
      this.loginTime = null;
      this.lastActivity = null;
      this.clearSessionMonitor();
      // optionally redirect to login page
      try {
        if (typeof window !== 'undefined' && window.location) {
          window.location.href = '/agent/home';
        }
      } catch (e) {
        console.error('Error occurred while redirecting to login page:', e);
      }
      console.log('Logged out by system:', reason);
    },
    logout() {
      this.performLogout('manual');
    },
  },

  getters: {
    getTokenLength() {
      return this.token ? this.token.length : 2;
    },
  },
  persist: true,
});

